module.exports = __webpack_public_path__ + "static/media/arcelik.68db5a77.svg";